'use strict';

angular.module('app')
    .controller('SpecialDealCtrl', function ($rootScope, $timeout, info, type, utils, regionList, diviacLocalStorage, DiveOperator, Search, $location, gettextCatalog) {
        var vm = this,
            selectedQueryFilters = false;

        
        vm.type = type;
        vm.changePage = changePage;
        vm.focusDropdown = focusDropdown;
        vm.setSelectedItem = setSelectedItem;
        vm.selectedElements = {country: []};
        vm.countries = info.activeCountryList;
        vm.regionList = regionList;
        vm.getPromotions = getPromotions;
        vm.clearFilters = clearFilters;
        vm.currentPage = $location.search().page || 1;
        vm.generateTitle = generateTitle;
        vm.updateDate = updateDate;
        vm.api = Search;
        $timeout(function() {
            vm.time = utils.genereateMonthPicker();
        })
        
        vm.diveOperatorTypes = [
            { id: 'la_deals', title: gettextCatalog.getString('Liveaboard') },
            { id: 'dr_deals', title: gettextCatalog.getString('Dive resort') }
        ]

        if ($location.search().country) {
            setQueryParameters ('country', 'countries', vm.countries, 'id');
        } 

        if ($location.search().region) {
            setQueryParameters ('region', 'regions', vm.regionList, 'id');
        }

        if ($location.search().first_month) {
            setSelectedItem(vm.time[0],'time', true);
            selectedQueryFilters = true;
        }

        if ($location.search().date) {
            setQueryParameters('date', 'time', vm.time, 'from');
        }

        getPromotions(vm.selectedElements, selectedQueryFilters);

        

        function setSelectedItem(item, type, preventFilter) {
            if (!_.isArray(vm.selectedElements[type])) {
                vm.selectedElements[type] = [];
            }
            var id = _.isObject(item) ? item.id : item;

            if (_.find(vm.selectedElements[type], {id:id})) {
                vm.selectedElements[type] = _.reject(vm.selectedElements[type], {id: id});
                item.checked = false;
            } else {
                item.checked = true;
                vm.selectedElements[type].push(item);
            }

            if (type === 'countries') {
                _.each(vm.selectedElements['regions'], function(val){
                    val.checked = false;
                });
                vm.selectedElements['regions'] = [];
            } else if (type === 'regions') {
                _.each(vm.selectedElements['countries'], function(val){
                    val.checked = false;
                });
                vm.selectedElements['countries'] = [];
            }


            if (preventFilter) {
                return true;
            }

            vm.currentPage = 1;
            $location.search('page',null);
            
            vm.url = window.location.href;
            getPromotions(vm.selectedElements);
        }

        function getPromotions(data, selectedQueryFilters) {
            vm.loader = true;

            var filter = {};

            if (data) {
                if (data.time) {
                    filter.date = [];
                    _.each(data.time, function(val){
                        if (val.id === 99) {
                            filter.first_month = true;
                        } else {
                            filter.date.push(val.from);
                        }
                    });
                }

                if (data.regions) {
                    filter.region = _.map(data.regions,'id');
                }

                if (data.countries) {
                    filter.country = _.map(data.countries,'id');
                }
            }

            if (!selectedQueryFilters) {
                $location.search('page',vm.currentPage);
                $location.search('date',filter.date);
                $location.search('first_month',filter.first_month);
                $location.search('country', filter.country);
                $location.search('region', filter.region);
            }

            return DiveOperator.getPromotions({page: vm.currentPage, page_size: 12},filter, type).then(function (data){
                vm.promotions = data.results;
                vm.promotionsCount = data.count;
                vm.loader = false;
            }).catch(function(error){
                if (error.status === 500) {
                    $rootScope.showNotify(gettextCatalog.getString('Something went wrong!'))
                }
            });
        }


        function setQueryParameters (query, fieldName, dataArray, arrayKey) {
            _.each(dataArray, function (val) {
                if (_.isArray($location.search()[query])) {
                    if (_.find($location.search()[query], function(v) {
                        return v == val[arrayKey];
                    })) {
                        setSelectedItem(val, fieldName, true);
                    }
                } else if (val[arrayKey] == $location.search()[query]) {
                    setSelectedItem(val, fieldName, true);
                }
            });
            selectedQueryFilters = true;
        }

        function generateTitle () {
            var title = gettextCatalog.getString('Best deals on') + ' '

            if (vm.type === 'la_deals') {
                title += gettextCatalog.getString('Liveaboards') + ' '
            } else {
                title += gettextCatalog.getString('Dive resorts') + ' '
            }

            title += '<br />'

            if (vm.selectedElements.countries && vm.selectedElements.countries.length && vm.selectedElements.countries.length <= 2) {
                _.each(vm.selectedElements.countries, function(val) {
                    title += ' ' + val.in_title + ' ' + gettextCatalog.getString('and') + ' '
                })
                title = title.slice(0, -4)
                title += '<br />'
            } else {
                title += gettextCatalog.getString('worldwide') + '<br/>'
            }


            if (vm.selectedElements.time && vm.selectedElements.time.length && vm.selectedElements.time.length <= 2) {
                _.each(vm.selectedElements.time, function(val) {
                    title += ' ' + gettextCatalog.getString('in {{ time }}', { time: val.title }) + ' ' + gettextCatalog.getString('and') + ' '
                })

                title = title.slice(0, -5)
            }

            return title

            // if (vm.selectedElements.time[0].id === 1) {
            //     return 'LAST MINUTE DEALS ON';
            // }

            // return vm.selectedElements.time[0].title.slice(0, -5) + " DEALS ON";
        }

        function changePage() {
            $location.path(utils.createURL(vm.type)).search('page', null);
        }

        function clearFilters() {
            vm.selectedElements.countries = [];
            vm.selectedElements.time = [];

            _.each(vm.countries, function(val) {
                val.checked = false;
            })

            _.each(vm.time, function(val) {
                val.checked = false;
            })

            getPromotions(vm.selectedElements);
        }
        
        function focusDropdown() {
            $timeout(function() {
                if (!sessionStorage.getItem('special-deals-dropdown')){
                    document.querySelector('#deal-type .selectize-input').click()
                    sessionStorage.setItem('special-deals-dropdown', true)
                } else if (!vm.selectedElements.time) {
                    document.getElementById('time-dropdown-btn').click()
                }
            }, 300)
        }

        function updateDate(dateFrom, dateTo, duration, resort) {
            var from = moment(dateFrom).format('YYYY-MM-DD');

            diviacLocalStorage.set('departure_date_custom', from)
            diviacLocalStorage.set('date', [from, moment(dateTo).format('YYYY-MM-DD')])
            
            if (duration) {
                diviacLocalStorage.set('duration', duration)
            }

            if (!diviacLocalStorage.get('roomParams') && resort) {
                diviacLocalStorage.set('roomParams', { id:2, divers :2, nonDivers :0, rooms :1})
            }
        }
    });
